import styled, { css, keyframes } from "styled-components"

const spin = keyframes`
  100% {
    transform: rotate(1turn);
  }
`

const Style = {
    "Btn": styled.button`
        position: relative;
        width: 100%;
        height: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        padding: 12px 0;
        background-color: ${({ theme }) => theme.color.major};
        color: ${({ theme }) => theme.color.white};
        ${({ theme }) => theme.font.small_bold};
        border-radius: 8px;

        ${({ $minor }) => $minor && css`
            background-color: ${({ theme }) => theme.color.grey2};
            color: ${({ theme }) => theme.color.white};
        `}

        ${({ $disabled }) => $disabled && css`
            background-color: ${({ theme }) => theme.color.grey2};
            color: ${({ theme }) => theme.color.white};
            cursor: not-allowed;
        `}

        ${({ $small }) => $small && css`
            ${({ theme }) => theme.font.extra_small_bold};
            padding: 8px 16px;
        `}

        ${({ $fitWidth }) => $fitWidth && css`
            width: fit-content;
        `}

        ${({ $expandHeight }) => $expandHeight && css`
            height: 100%;
        `}

        ${({ $loading }) => $loading && css`
            opacity: 0.9;
        `}
    `,
    "LoadingOverlay": styled.div`
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    `,
    "LoadingSpinner": styled.div`
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: 
            radial-gradient(farthest-side, #ED3241 94%, transparent) top/2px 2px no-repeat,
            conic-gradient(transparent 30%, #ED3241);
        -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 2px), #000 0);
        mask: radial-gradient(farthest-side, transparent calc(100% - 2px), #000 0);
        animation: ${spin} 1s infinite linear;
    `,
}

export default Style